export default __webpack_public_path__ + "static/1038-da25a31ac2c242ee45700aba8695e49a.gif";